import i18next from 'i18next'
import {CaptureMethod} from '@/types/transactions'

export const getPOSCaptureMethods = () =>
    [
        CaptureMethod.pos,
        CaptureMethod['pos-contactless'],
        CaptureMethod.stored,
        CaptureMethod.moto,
        CaptureMethod.recurring,
        CaptureMethod['pos-openbanking'],
        CaptureMethod['pos-alipay']
    ].map((key) => ({
        value: key,
        label: key ? i18next.t(`enums:captureMethods.${key}`, {defaultValue: key}) : ''
    }))
